import NoData from '../../../../../../components/NoData';
import { Card } from './styles';

interface ISlaCard {
  sla: number
}

export default function SlaCard({ sla }: ISlaCard) {
  return (
    <Card>
      <div className="card-title">
        <div>SLA Médio - Tempo de Resposta</div>
      </div>

      {!!sla && (
        <>
          <div className="card-main">
            <div style={{fontSize: '32px'}}>
              {sla.toFixed(0)}
            </div>
            <small>
              {(sla > 1 ? 'Minutos' : 'Minuto')}
            </small>
          </div>
        </>
      )}

      {(!sla) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados a respeito do SLA
            </>
          )}
        />
      )}
    </Card>
  );
}
